export const PAGE_STATE_CACHE_ADD_PAGE_STATE =
  'PAGE_STATE_CACHE_ADD_PAGE_STATE';
export const PAGE_STATE_CACHE_REMOVE_PAGE_STATE =
  'PAGE_STATE_CACHE_REMOVE_PAGE_STATE';



// WEBPACK FOOTER //
// ./src/state/pagestatecache/types.js